import styled from "styled-components";
import { MainBlock, MainBodyText, MainFrameImage, MainHeading, MainHeadingBlock, MainHeadingGrey, MainImage, MainSection } from "../../../components/01_config/MainStyles";

const GoalSection = styled(MainSection)`
    padding-top: 60px;
`

const LeftColumnWrapper = styled(MainBlock)`
    height: fit-content;
    gap: 25px;
`

const GoalHeadingGrey = styled(MainHeadingGrey)`

`

const GoalHeadingBlock = styled(MainHeadingBlock)`

`

const GoalBodyText = styled(MainBodyText)`
    white-space: pre-line;
`

const RightColumnWrapper = styled(MainBlock)`

`

const GoalImage = styled(MainImage)`

`

const UnorderedList = styled.ul`
    width: 100%;
    padding-left: 40px;
`

const Bullets = styled.li`
    margin: 10px 0;
`

export { GoalSection, LeftColumnWrapper, GoalHeadingGrey, GoalHeadingBlock, GoalBodyText, RightColumnWrapper, GoalImage, UnorderedList, Bullets }